/* ============================================================================
   Pet's Table — /pages/order: carrito lateral
   ----------------------------------------------------------------------------
   La página no mostraba el carrito. Quien iba al checkout, se arrepentía y
   volvía atrás encontraba el formulario en blanco: lo llenaba otra vez,
   agregaba, y terminaba con dos planes sin saberlo. La única forma de
   arreglarlo era descubrir que existe /cart y borrar uno ahí.

   La primera versión de este archivo borraba los planes anteriores antes de
   agregar. Resolvía el duplicado accidental, pero impedía algo legítimo: un
   plan por cada perro. Se cambió por esto.

   El carrito de Shopify ya sobrevive al volver atrás; lo que faltaba era
   enseñarlo. Con el carrito a la vista, el duplicado accidental deja de ser
   invisible: se ve y se quita de un toque, y de paso se puede armar otro plan
   para otro perro a propósito.

   Va aparte porque pt-plan-builder se reescribe cada tanto.
   ========================================================================== */
(function () {
  'use strict';

  var abierto = false;
  var carrito = { items: [], item_count: 0, total_price: 0 };

  function dinero(centavos) {
    return '$' + (centavos / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2, maximumFractionDigits: 2,
    });
  }

  /** Nombre del perro de una línea. La propiedad lleva guion bajo para no
      mostrarse suelta en el carrito de Shopify; las órdenes viejas no lo
      tienen. */
  function nombrePerro(item) {
    var p = item.properties || {};
    return p._Perro || p.Perro || '';
  }

  /* El 40% de la primera caja se aplica con un código en el checkout, así que
     el carrito de Shopify todavía enseña el precio completo. Mostrarlo solo
     así confunde: el cliente ve una cifra aquí y otra al pagar. Se enseñan las
     dos, con la de lista tachada, que es lo mismo que hace el formulario. */
  var DESCUENTO_PRIMERA = 0.4;

  /* Cada cuánto llega, sacado del SKU: ...-QUI-... quincenal, ...-MEN-...
     mensual. Sin esto, dos líneas con distinta frecuencia se ven igual y el
     precio no se entiende — arriba en el formulario sí se dice, y el carrito
     tenía que decirlo también. */
  function frecuencia(item) {
    var sku = String((item.sku || '') + ' ' + (item.variant_title || ''));
    if (/-QUI-|QUI/.test(sku)) return 'quincenal';
    if (/-MEN-|MEN/.test(sku)) return 'mensual';
    var p = item.properties || {};
    var f = p._Frecuencia || p.Frecuencia || '';
    if (/qui/i.test(f)) return 'quincenal';
    if (/men/i.test(f)) return 'mensual';
    return '';
  }

  function precioLinea(item, esSuscripcion) {
    var lista = item.final_line_price;
    var cada = frecuencia(item);
    var etiqueta = cada ? ' <span class="pt-cart-cada">' + cada + '</span>' : '';

    if (!esSuscripcion || !DESCUENTO_PRIMERA) {
      return '<div class="pt-cart-precio">' + dinero(lista) + etiqueta + '</div>';
    }
    var conDesc = Math.round(lista * (1 - DESCUENTO_PRIMERA));
    return '' +
      '<div class="pt-cart-precio">' +
        '<b>' + dinero(conDesc) + '</b>' + etiqueta +
        '<s>' + dinero(lista) + '</s>' +
      '</div>' +
      '<div class="pt-cart-desc">−' + Math.round(DESCUENTO_PRIMERA * 100) + '% en tu primer pedido</div>';
  }

  function esPlan(item) {
    var p = item.properties || {};
    return !!(p._Formulario_Id || p.Formulario_Id || nombrePerro(item));
  }

  async function leer() {
    try {
      var r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      carrito = await r.json();
    } catch (e) { /* si no se puede leer, el carrito se queda como estaba */ }
    pintar();
  }

  /* ── Interfaz ─────────────────────────────────────────────────────────── */

  function construir() {
    if (document.getElementById('ptCarrito')) return;

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.id = 'ptCarritoBtn';
    boton.className = 'pt-cart-btn';
    boton.setAttribute('aria-label', 'Ver tu carrito');
    boton.innerHTML = '<span class="pt-cart-ico">🛒</span><span class="pt-cart-num" id="ptCarritoNum">0</span>';
    boton.addEventListener('click', function () { alternar(true); });
    document.body.appendChild(boton);

    var fondo = document.createElement('div');
    fondo.className = 'pt-cart-fondo';
    fondo.id = 'ptCarritoFondo';
    fondo.addEventListener('click', function () { alternar(false); });
    document.body.appendChild(fondo);

    var panel = document.createElement('aside');
    panel.id = 'ptCarrito';
    panel.className = 'pt-cart';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Tu carrito');
    panel.innerHTML =
      '<div class="pt-cart-head">' +
        '<strong>Tu pedido</strong>' +
        '<button type="button" class="pt-cart-x" aria-label="Cerrar">✕</button>' +
      '</div>' +
      '<div class="pt-cart-body" id="ptCarritoBody"></div>' +
      '<div class="pt-cart-pie" id="ptCarritoPie"></div>';
    panel.querySelector('.pt-cart-x').addEventListener('click', function () { alternar(false); });
    document.body.appendChild(panel);

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && abierto) alternar(false);
    });
  }

  function alternar(abrir) {
    abierto = !!abrir;
    document.getElementById('ptCarrito').classList.toggle('pt-abierto', abierto);
    document.getElementById('ptCarritoFondo').classList.toggle('pt-abierto', abierto);
    document.body.classList.toggle('pt-cart-bloqueado', abierto);
    if (abierto) {
      leer();
      var x = document.querySelector('#ptCarrito .pt-cart-x');
      if (x) x.focus();
    }
  }

  function pintar() {
    var body = document.getElementById('ptCarritoBody');
    var pie = document.getElementById('ptCarritoPie');
    var num = document.getElementById('ptCarritoNum');
    var btn = document.getElementById('ptCarritoBtn');
    if (!body || !pie) return;

    var planes = (carrito.items || []).filter(esPlan);
    var otros = (carrito.items || []).filter(function (i) { return !esPlan(i); });

    if (num) num.textContent = carrito.item_count || 0;
    /* El botón solo aparece cuando hay algo: un carrito vacío flotando
       distrae en un formulario que todavía no tiene nada. */
    if (btn) btn.classList.toggle('pt-visible', (carrito.item_count || 0) > 0);

    if (!carrito.items || !carrito.items.length) {
      body.innerHTML = '<p class="pt-cart-vacio">Todavía no has agregado ningún plan.</p>';
      pie.innerHTML = '';
      return;
    }

    body.innerHTML = planes.concat(otros).map(function (it) {
      var perro = nombrePerro(it);
      var sub = !!it.selling_plan_allocation;

      /* Cada suscripción es un perro distinto, así que su nombre es lo que
         identifica la línea. Cuando falta —el campo es opcional— se dice
         "Plan sin nombre" en vez de dejar solo el título del producto, que es
         igual en todas las líneas y no permite distinguirlas. */
      var titulo = perro
        ? 'Plan de ' + escapar(perro)
        : (sub ? 'Plan sin nombre' : escapar(it.product_title || it.title || ''));

      return '' +
        '<div class="pt-cart-item">' +
          (it.image ? '<img src="' + it.image + '&width=120" alt="" width="60" height="60">' : '') +
          '<div class="pt-cart-info">' +
            '<div class="pt-cart-perro">' + titulo + '</div>' +
            '<div class="pt-cart-titulo">' + escapar(it.product_title || it.title || '') + '</div>' +
            (sub ? '<div class="pt-cart-sub">Suscripción</div>' : '') +
            precioLinea(it, sub) +
          '</div>' +
          '<button type="button" class="pt-cart-quitar" data-key="' + it.key + '" ' +
                  'aria-label="Quitar ' + (perro ? 'el plan de ' + escapar(perro) : 'este artículo') + '">Quitar</button>' +
        '</div>';
    }).join('');

    Array.prototype.forEach.call(body.querySelectorAll('.pt-cart-quitar'), function (b) {
      b.addEventListener('click', function () { quitar(b.dataset.key, b); });
    });

    /* El total del carrito NO lleva IVA: Shopify lo suma en el checkout. Se
       dice en vez de callarlo, que es justo lo que provocaba la sorpresa del
       16% al final. */
    /* El total sigue la misma lógica que las líneas: si hay suscripciones con
       descuento de primera caja, se enseña lo que va a pagar y se tacha el de
       lista. Si no, un solo número. */
    var listaSub = planes.filter(function (i) { return !!i.selling_plan_allocation; })
                         .reduce(function (a, i) { return a + i.final_line_price; }, 0);
    var resto = carrito.total_price - listaSub;
    var totalConDesc = Math.round(listaSub * (1 - DESCUENTO_PRIMERA)) + resto;

    pie.innerHTML =
      (listaSub
        ? '<div class="pt-cart-total"><span>Total hoy</span>' +
            '<span><b>' + dinero(totalConDesc) + '</b><s>' + dinero(carrito.total_price) + '</s></span></div>' +
          '<div class="pt-cart-ahorro">Ahorras ' + dinero(carrito.total_price - totalConDesc) + ' en tu primer pedido</div>'
        : '<div class="pt-cart-total"><span>Subtotal</span><b>' + dinero(carrito.total_price) + '</b></div>') +
      '<div class="pt-cart-nota">El descuento se aplica en el pago. Impuestos y envío se calculan ahí también.</div>' +
      '<a href="/checkout" class="btn btn-org pt-cart-ir">Continuar al pago</a>' +
      '<button type="button" class="pt-cart-seguir" id="ptCarritoSeguir">Armar plan para otro perro</button>';

    var seguir = document.getElementById('ptCarritoSeguir');
    if (seguir) {
      seguir.addEventListener('click', function () {
        /* Se cierra y se sube al formulario: el plan que ya está queda en el
           carrito y el siguiente se agrega aparte, uno por perro. */
        alternar(false);
        var arriba = document.querySelector('#breedInput') || document.body;
        arriba.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  function escapar(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  async function quitar(key, boton) {
    if (boton) { boton.disabled = true; boton.textContent = '…'; }
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
    } catch (e) {}
    await leer();
  }

  /* ── Enganches ────────────────────────────────────────────────────────── */

  /* Al agregar algo se abre el carrito: es la confirmación de que se agregó y,
     si quedó un plan de un intento anterior, se ve en ese momento en vez de
     descubrirse en el checkout. */
  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal === 'function') {
    window.fetch = function (entrada) {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var p = fetchOriginal.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1) {
        p.then(function () { setTimeout(function () { leer(); alternar(true); }, 400); }, function () {});
      }
      return p;
    };
  }

  /* Al volver del checkout con el botón atrás, el navegador puede servir la
     página desde su caché sin recargarla; sin esto el carrito se vería vacío
     aunque tenga cosas. */
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) leer(); });

  function arrancar() { construir(); leer(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  window.PT_CARRITO = { abrir: function () { alternar(true); }, recargar: leer };
})();
